import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { KnowledgeFilesService } from './knowledgeFilesApi';
import { AxiosError } from 'axios';

const initialState: any = {
    filesAreLoading: false,
    fileIsLoading: false,
    requestStatus: 'default',
    message: '',
};

export const tryToFetchKnowledgeFiles = createAsyncThunk<any, undefined>(
    'knowledgeFiles/tryToFetchKnowledgeFiles',
    async () => {
        const result = await KnowledgeFilesService.tryToFetchKnowledgeFiles();
        return result?.data?.data;
    }
);

export const tryToUploadKnowledgeFiles = createAsyncThunk<any, any>(
    'knowledgeFiles/tryToUploadKnowledgeFiles',
    async (data, { rejectWithValue }) => {
        try {
            const result = await KnowledgeFilesService.tryToUploadKnowledgeFiles(data);
            return result.data;
        } catch (error) {
            const err: any = error as AxiosError;
            return rejectWithValue(err?.response?.data?.message);
        }
    },
);

export const tryToDeleteKnowledgeFile = createAsyncThunk<any, any>(
    'knowledgeFiles/tryToDeleteKnowledgeFile',
    async (id, { rejectWithValue }) => {
        try {
            const result = await KnowledgeFilesService.tryToDeleteKnowledgeFile(id);
            return result.data;
        } catch (error) {
            const err: any = error as AxiosError;
            return rejectWithValue(err?.response?.data?.message);
        }
    },
);

export const knowledgeFilesSlice = createSlice({
    name: 'knowledgeFiles',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // tryToFetchKnowledgeFiles
            .addCase(tryToFetchKnowledgeFiles.pending, (state) => {
                state.filesAreLoading = true;
            })
            .addCase(tryToFetchKnowledgeFiles.rejected, (state) => {
                state.filesAreLoading = false;
            })
            .addCase(tryToFetchKnowledgeFiles.fulfilled, (state, action) => {
                state.filesAreLoading = false;
                state.knowledgeFiles = action.payload;
            })

            // tryToUploadKnowledgeFiles
            .addCase(tryToUploadKnowledgeFiles.pending, (state) => {
                state.fileIsLoading = true;
            })
            .addCase(tryToUploadKnowledgeFiles.rejected, (state) => {
                state.fileIsLoading = false;
            })
            .addCase(tryToUploadKnowledgeFiles.fulfilled, (state, action) => {
                state.fileIsLoading = false;
                state.knowledgeFiles = [...state?.knowledgeFiles || [], action.payload]
            })

            // tryToDeleteKnowledgeFile
            .addCase(tryToDeleteKnowledgeFile.pending, (state) => {
                state.fileIsLoading = true;
            })
            .addCase(tryToDeleteKnowledgeFile.rejected, (state) => {
                state.fileIsLoading = false;
            })
            .addCase(tryToDeleteKnowledgeFile.fulfilled, (state, action) => {
                state.fileIsLoading = false;
                if (state.knowledgeFiles)
                    state.knowledgeFiles =
                        { ...state }.knowledgeFiles?.filter((file: any) => file._id !== action.meta.arg) || [];
            })

    },
});

export default knowledgeFilesSlice.reducer;